// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hnTc","importantInfo":"styles_importantInfo__3d7WS"};